export default __webpack_public_path__ + "static/media/bunnybutt.25de7046.svg";